// extracted by mini-css-extract-plugin
export default {"image":"f8bbUKOYiZXelUykG880"};